module.exports = __webpack_public_path__ + "static/media/Altia_logo2.a3668a95.png";